
class EraseUtils {
  formDefaultConfig() {
    return {
      "layout": "vertical",
      "labelCol": {
        "xs": 4,
        "sm": 4,
        "md": 4,
        "lg": 4,
        "xl": 4,
        "xxl": 4
      },
      "labelWidth": 100,
      "labelLayout": "flex",
      "wrapperCol": {
        "xs": 18,
        "sm": 18,
        "md": 18,
        "lg": 18,
        "xl": 18,
        "xxl": 18
      },
      "hideRequiredMark": false,
      "customStyle": {
        padding: "0px 10%"
      }
    };
  }
  /**
   * 将远程获取的数据转换为 K-Form-Design 可以识别的数组结构
   */
  parseFormItemsData(formItemsData, parentOptions = []) {
    let formDesignList = [];

    for (let item of formItemsData) {
      let formItem = this.parseFormItemsSingleData(item, parentOptions);

      if (formItem) {
        // 如果返回的是数组（父子题情况），则展开数组
        if (Array.isArray(formItem)) {
          formDesignList = formDesignList.concat(formItem);
        } else {
          formDesignList.push(formItem);
        }
      }
    }

    return formDesignList;
  }
  // 解析单个题目数据,将后端数据转换为完整的表单记录对象
  parseFormItemsSingleData(item, parentOptions = []) {
    let common = {
      "parent": item.parent,
      "code": item.code,
      "dictItemList": item.dictItemList,
      "minLength": item.minLength,
      "delFlag": item.delFlag,
      "isLeaf": item.isLeaf,
      "children": item.children,
      "parentCode": item.parentCode,
      "sortNum": item.sortNum,
      "id": item.id,
      "parentValue": item.parentValue,
      "formCode": item.formCode,
      "formId": item.formId,
      "length": item.length,
      "formTip": item.formTip,
      "reDecimal": item.reDecimal,
      "decimalPoint": item.decimalPoint,
      "unit": item.unit,
      "checkReg": item.checkReg,
      "parentOptions": parentOptions,
      "parentValueList": [],
    }

    let sequence = '';
    if (item.number) {
      sequence = item.number;
    }
    let help = item.inputTip;
    let label = item.name;
    let model = item.id;
    let key = item.id;
    let description = item.description;
    let disabled = false;
    if (item.disabled == '1') {
      disabled = true;
    }
    let conceal = false;
    if (item.conceal == '1') {
      conceal = true;
    }
    let scale = false;
    if (item.scale == '1') {
      scale = true;
    }
    let draw = false;
    if (item.draw == '1') {
      draw = true;
    }
    let important = false;
    if (item.important == '1') {
      important = true;
    }
    let required = false;
    if (item.required == '1') {
      required = true;
    }
    let reDecimal = false;
    if (item.reDecimal == '1') {
      reDecimal = true;
    }

    // 如果有子题目，直接返回父题目和子题目列表，而不是包装在emptyCard中
    if (item.children) {
      let options;

      if (item.dictItemJson) {
        options = JSON.parse(item.dictItemJson).map(item => {
          return {
            "value": item.value,
            "label": item.text,
            "mappingValue": item.mappingValue,
            "description": item.description,
            "sortNum": item.sortNum,
            "img": item.img,
            "defaultValue": item.defaultValue,
          };
        });
      }

      let childrenList = this.parseFormItemsData(item.children, options);

      /**
       * 为了不改变原始数据，将数据进行了复制。
       */
      let orgParent = JSON.parse(JSON.stringify(item));
      orgParent.children = null;
      let parent = this.parseFormItemsSingleData(orgParent, options)

      // 返回父题目和子题目列表，直接在线性列表中展示
      let result = [parent];
      result = result.concat(childrenList);
      return result;
    }

    let rule = [
      {
        "required": required,
        "message": "必填项"
      }
    ]

    if (item.type === 'select') {
      let options;

      if (item.dictItemJson) {
        options = JSON.parse(item.dictItemJson).map(item => {
          return {
            "value": item.value,
            "label": item.text,
            "mappingValue": item.mappingValue,
            "description": item.description,
            "sortNum": item.sortNum,
            "img": item.img,
            "defaultValue": item.defaultValue,
          };
        });
      }

      return {
        "itemType": "FROM_BACKEND",
        "type": "radio",
        "commponentTypeName": "单选",
        "sequence": sequence,
        "required": required,
        "disabled": disabled,
        "conceal": conceal,
        "scale": scale,
        "draw": draw,
        "important": important,
        "img": item.img,
        "label": label,
        "options": {
          "width": "100%",
          "multiple": false,
          "disabled": false,
          "clearable": false,
          "showLabel": true,
          "hidden": false,
          "placeholder": "请做出单选",
          "dynamicKey": "",
          "options": options,
          "showSearch": false
        },
        "model": model,
        "key": key,
        "help": help,
        "rules": rule,
        "common": common,
        "description": description
      }
    } else if (item.type === 'file') {
      return {
        "itemType": "FROM_BACKEND",
        "type": "uploadFile",
        "commponentTypeName": "文件",
        "sequence": sequence,
        "required": required,
        "disabled": disabled,
        "conceal": conceal,
        "scale": scale,
        "draw": draw,
        "important": important,
        "img": item.img,
        "label": label,
        "options": {
          "defaultValue": "[]",
          "multiple": false,
          "disabled": false,
          "showLabel": true,
          "hidden": false,
          "drag": false,
          "downloadWay": "a",
          "dynamicFun": "",
          "width": "100%",
          "limit": 3,
          "data": "{}",
          "fileName": "file",
          "headers": {},
          "action": "https://examples.epicjs.cn/epic-mock/common/upload",
          "placeholder": "请上传文件"
        },
        "model": model,
        "key": key,
        "help": help,
        "rules": rule,
        "common": common,
        "description": description
      }
    } else if (item.type === 'slider') {
      return {
        "itemType": "FROM_BACKEND",
        "type": "slider",
        "commponentTypeName": "滑行数字",
        "sequence": sequence,
        "required": required,
        "disabled": disabled,
        "conceal": conceal,
        "scale": scale,
        "draw": draw,
        "important": important,
        "img": item.img,
        "label": label,
        "options": {
          "width": "100%",
          "defaultValue": 0,
          "disabled": false,
          "showLabel": true,
          "hidden": false,
          "min": item.minLength,
          "max": item.length,
          "step": 1,
          "unit": item.unit,
          "showInput": false
        },
        "model": model,
        "key": key,
        "help": help,
        "rules": rule,
        "common": common,
        "description": description
      }
    } else if (item.type === 'text') {
      return {
        "itemType": "FROM_BACKEND",
        "type": "input",
        "commponentTypeName": "文本",
        "sequence": sequence,
        "required": required,
        "disabled": disabled,
        "conceal": conceal,
        "scale": scale,
        "draw": draw,
        "important": important,
        "img": item.img,
        "label": label,
        "options": {
          "type": "text",
          "width": "100%",
          "defaultValue": "",
          "placeholder": "请输入文本",
          "clearable": false,
          "maxLength": item.length,
          "minLength": item.minLength,
          "checkReg": item.checkReg,
          "addonBefore": "",
          "addonAfter": item.unit,
          "showLabel": true,
          "hidden": false,
          "disabled": false
        },
        "model": model,
        "key": key,
        "help": help,
        "rules": rule,
        "common": common,
        "description": description
      }
    } else if (item.type === 'textarea') {
      return {
        "itemType": "FROM_BACKEND",
        "type": "textarea",
        "commponentTypeName": "多文本",
        "sequence": sequence,
        "required": required,
        "disabled": disabled,
        "conceal": conceal,
        "scale": scale,
        "draw": draw,
        "important": important,
        "img": item.img,
        "label": label,
        "options": {
          "minRows": 4,
          "maxRows": 6,
          "width": "100%",
          "defaultValue": "",
          "placeholder": "请输入文本",
          "clearable": false,
          "maxLength": item.length,
          "minLength": item.minLength,
          "checkReg": item.checkReg,
          "addonBefore": "",
          "unit": item.unit,
          "showLabel": true,
          "hidden": false,
          "disabled": false
        },
        "model": model,
        "key": key,
        "help": help,
        "rules": rule,
        "common": common,
        "description": description
      }
    } else if (item.type === 'check') {
      let options;

      if (item.dictItemJson) {
        options = JSON.parse(item.dictItemJson).map(item => {
          return {
            "value": item.value,
            "label": item.text,
            "mappingValue": item.mappingValue,
            "description": item.description,
            "sortNum": item.sortNum,
            "img": item.img,
            "defaultValue": item.defaultValue,
          };
        });
      }

      return {
        "itemType": "FROM_BACKEND",
        "type": "checkbox",
        "commponentTypeName": "多选",
        "sequence": sequence,
        "required": required,
        "disabled": disabled,
        "conceal": conceal,
        "scale": scale,
        "draw": draw,
        "important": important,
        "img": item.img,
        "label": label,
        "options": {
          "disabled": false,
          "showLabel": true,
          "hidden": false,
          "defaultValue": [],
          "dynamicKey": "",
          "dynamic": false,
          "options": options
        },
        "model": model,
        "key": key,
        "help": help,
        "rules": rule,
        "common": common,
        "description": description
      }
    } else if (item.type === 'number') {
      return {
          "itemType": "FROM_BACKEND",
          "type": "knumber",
          "commponentTypeName": "数字",
          "sequence": sequence,
          "required": required,
          "disabled": disabled,
          "conceal": conceal,
          "scale": scale,
          "draw": draw,
          "important":important,
          "img": item.img,
          "label": label,
          "options": {
            "width": "100%",
            "defaultValue": null,
            "min": item.minLength,
            "max": item.length,
            "unit": item.unit,
            "precision": null,
            "showLabel": true,
            "hidden": false,
            "disabled": false,
            "placeholder": "请输入数字",
            "reDecimal": reDecimal,
            "decimalPoint":item.decimalPoint,
            "checkReg": item.checkReg,
          },
          "model": model,
          "key": key,
          "help": help,
          "rules": rule,
          "common": common,
          "description": description
        }
    } else if (item.type === 'time'|| item.type === 'hour' || item.type === 'minute') {
      return {
          "itemType": "FROM_BACKEND",
          "type": "time",
          "commponentTypeName": "时间",
          "sequence": sequence,
          "required": required,
          "disabled": disabled,
          "conceal": conceal,
          "scale": scale,
          "draw": draw,
          "important":important,
          "img": item.img,
          "label": label,
          "options": {
            "width": "100%",
            "defaultValue": "",
            "disabled": false,
            "showLabel": true,
            "hidden": false,
            "clearable": false,
            "placeholder": "请选择时间",
            "format": "HH:mm"
          },
          "model": model,
          "key": key,
          "help": help,
          "rules": rule,
          "common": common,
          "description": description,
          "typeNew": item.type // 用于前端区分是日期还是年月，后续可以删除
        }
    } else if (item.type === 'date'|| item.type === 'dateyear') {
      return {
          "itemType": "FROM_BACKEND",
          "type": "date",
          "commponentTypeName": "日期",
          "sequence": sequence,
          "required": required,
          "disabled": disabled,
          "conceal": conceal,
          "scale": scale,
          "draw": draw,
          "important":important,
          "img": item.img,
          "label": label,
          "options": {
            "width": "100%",
            "defaultValue": "",
            "rangeDefaultValue": [],
            "range": false,
            "showTime": false,
            "disabled": false,
            "showLabel": true,
            "hidden": false,
            "clearable": false,
            "placeholder": "请选择日期",
            "rangePlaceholder": [
              "开始时间",
              "结束时间"
            ],
            "format": "YYYY-MM-DD"
          },
          "model": model,
          "key": key,
          "help": help,
          "rules": rule,
          "common": common,
          "description": description,
          "typeNew": item.type // 用于前端区分是日期还是年月，后续可以删除
        }
    } else if (item.type === 'dateTime') {
      return {
        "itemType": "FROM_BACKEND",
        "type": "datetime",
        "commponentTypeName": "时间",
        "sequence": sequence,
        "required": required,
        "disabled": disabled,
        "conceal": conceal,
        "scale": scale,
        "draw": draw,
        "important": important,
        "img": item.img,
        "label": label,
        "options": {
          "width": "100%",
          "defaultValue": "",
          "rangeDefaultValue": [],
          "range": false,
          "showTime": { format: 'HH:mm' },
          "disabled": false,
          "showLabel": true,
          "hidden": false,
          "clearable": false,
          "placeholder": "请选择时间",
          "rangePlaceholder": [
            "开始时间",
            "结束时间"
          ],
          "format": "YYYY-MM-DD HH:mm"
        },
        "model": model,
        "key": key,
        "help": help,
        "rules": rule,
        "common": common,
        "description": description
      }
    } else if (item.type === 'table') {
      // 将后端数据转换单元格内容为完整的表单记录对象
      let trs = [];
      let isAddRow = false;
      if (item.trs) {
        try {
          // trs=JSON.parse(item.trs); 
          trs = typeof item.trs === 'string' ? JSON.parse(item.trs) : item.trs;
          trs.forEach(tr => {
            if (tr.tds) {
              tr.tds.forEach(td => {
                if (td.list && Array.isArray(td.list) && td.list.length > 0) {
                  td.colspan = Number(td.colspan) || 1;
                  td.rowspan = Number(td.rowspan) || 1;
                  td.list = td.list.map(item => {
                    if (item.type === 'checkbox') {
                      return {
                        "type": "checkbox",
                        "label": item.label || "",
                        "options": {
                          "type": "checkbox",
                          "width": "100%",
                          "defaultValue": "1",
                          "placeholder": "",
                          "clearable": false,
                          "showLabel": false,
                          "hidden": false,
                          "disabled": false,
                          "options": item.options || [],
                        },
                        "model": "table_cell_" + new Date().getTime() + "_" + Math.random().toString(36).substr(2, 9),
                        "key": "table_cell_" + new Date().getTime() + "_" + Math.random().toString(36).substr(2, 9),
                        "help": "",
                        "rules": [],
                        "isTableCell": true,
                        "isChecked": true,
                        "isRadio": false,
                        //"common": item.common || {}
                      };
                    }else if (item.type === 'radio') {
                      return {
                        "type": "radio",
                        "label": item.label || "",
                        "options": {
                          "type": "radio",
                          "width": "100%",
                          "defaultValue": "1",
                          "placeholder": "",
                          "clearable": false,
                          "showLabel": false,
                          "hidden": false,
                          "disabled": false,
                          "options": item.options || [],
                        },
                        "model": "table_cell_" + new Date().getTime() + "_" + Math.random().toString(36).substr(2, 9),
                        "key": "table_cell_" + new Date().getTime() + "_" + Math.random().toString(36).substr(2, 9),
                        "help": "",
                        "rules": [],
                        "isTableCell": true,
                        "isChecked": false,
                        "isRadio": true,
                        //"common": item.common || {}
                      };
                    } else {
                      // 将字符串转换为文本输入框对象
                      return {
                        "type": "input",
                        "label": item.label || "",
                        "options": {
                          "type": "text",
                          "width": "100%",
                          "defaultValue": item.label || "",
                          "placeholder": "",
                          "clearable": false,
                          "showLabel": false,
                          "hidden": false,
                          "disabled": false
                        },
                        "model": "table_cell_" + new Date().getTime() + "_" + Math.random().toString(36).substr(2, 9),
                        "key": "table_cell_" + new Date().getTime() + "_" + Math.random().toString(36).substr(2, 9),
                        "help": "",
                        "rules": [],
                        "isTableCell": true,
                        "isChecked": false,
                        "isRadio": false,
                        //"common": item.common || {}
                      };
                    }
                  });
                }
              });
            }
            if(tr.isAddRow){
              isAddRow = true;
            }
          });
        } catch (e) {
          console.error('解析表格trs数据失败:', e);
          trs = [];
        }
      } else {
        // 默认表格结构
        trs = [{
          "tds": [{
            "colspan": 1,
            "rowspan": 2,
            "list": [{
              "type": "input",
              "label": "扫描部位",
              "options": {
                "type": "text",
                "width": "100%",
                "defaultValue": "扫描部位",
                "placeholder": "",
                "clearable": false,
                "showLabel": false,
                "hidden": false,
                "disabled": false
              },
              "model": "table_cell_1772779777997_5tan3jhys",
              "key": "table_cell_1772779777997_1hjptyk9x",
              "help": "",
              "rules": [],
              "isTableCell": true,
              "common": {
                "parentValueList": [],
                "code": "DISC-1772782065973-4273"
              }
            }]
          }, {
            "colspan": 2,
            "rowspan": 1,
            "list": [{
              "type": "input",
              "label": "胸透评分",
              "options": {
                "type": "text",
                "width": "100%",
                "defaultValue": "胸透评分",
                "placeholder": "",
                "clearable": false,
                "showLabel": false,
                "hidden": false,
                "disabled": false
              },
              "model": "table_cell_1772782058281_bjs5ylzoh",
              "key": "table_cell_1772782058281_6hcpqr68k",
              "help": "",
              "rules": [],
              "isTableCell": true,
              "common": {
                "parentValueList": [],
                "code": "DISC-1772782077526-4282"
              }
            }]
          }, {
            "colspan": 0,
            "rowspan": 1,
            "list": []
          }]
        }, {
          "tds": [{
            "colspan": 0,
            "rowspan": 0,
            "list": []
          }, {
            "colspan": 1,
            "rowspan": 1,
            "list": [{
              "type": "input",
              "label": "左侧",
              "options": {
                "type": "text",
                "width": "100%",
                "defaultValue": "左侧",
                "placeholder": "",
                "clearable": false,
                "showLabel": false,
                "hidden": false,
                "disabled": false
              },
              "model": "table_cell_1772782058281_9d902961s",
              "key": "table_cell_1772782058281_tq9x7c1b7",
              "help": "",
              "rules": [],
              "isTableCell": true,
              "common": {
                "parentValueList": [],
                "code": "DISC-1772782087517-8338"
              }
            }]
          }, {
            "colspan": 1,
            "rowspan": 1,
            "list": [{
              "type": "input",
              "label": "右侧",
              "options": {
                "type": "text",
                "width": "100%",
                "defaultValue": "右侧",
                "placeholder": "",
                "clearable": false,
                "showLabel": false,
                "hidden": false,
                "disabled": false
              },
              "model": "table_cell_1772782056440_irdadeloe",
              "key": "table_cell_1772782056440_lmux30idx",
              "help": "",
              "rules": [],
              "isTableCell": true,
              "common": {
                "parentValueList": [],
                "code": "DISC-1772782092254-5090"
              }
            }]
          }]
        }, {
          "tds": [{
            "colspan": 1,
            "rowspan": 1,
            "list": [{
              "type": "input",
              "label": "前胸碧上",
              "options": {
                "type": "text",
                "width": "100%",
                "defaultValue": "前胸碧上",
                "placeholder": "",
                "clearable": false,
                "showLabel": false,
                "hidden": false,
                "disabled": false
              },
              "model": "table_cell_1772782052137_rh0c4p1ww",
              "key": "table_cell_1772782052137_5cdie57hu",
              "help": "",
              "rules": [],
              "isTableCell": true,
              "common": {
                "parentValueList": [],
                "code": "DISC-1772782096927-6253"
              }
            }]
          }, {
            "colspan": 1,
            "rowspan": 1,
            "list": [{
              "type": "input",
              "label": "",
              "options": {
                "type": "text",
                "width": "100%",
                "defaultValue": "",
                "placeholder": "",
                "clearable": false,
                "showLabel": false,
                "hidden": false,
                "disabled": false
              },
              "model": "table_cell_1772782058281_l7zh4r6qv",
              "key": "table_cell_1772782058281_1tqaflja2",
              "help": "",
              "rules": [],
              "isTableCell": true
            }]
          }, {
            "colspan": 1,
            "rowspan": 1,
            "list": [{
              "type": "input",
              "label": "",
              "options": {
                "type": "text",
                "width": "100%",
                "defaultValue": "",
                "placeholder": "",
                "clearable": false,
                "showLabel": false,
                "hidden": false,
                "disabled": false
              },
              "model": "table_cell_1772782056440_nwpc8kyf8",
              "key": "table_cell_1772782056440_zbqwyrycj",
              "help": "",
              "rules": [],
              "isTableCell": true
            }]
          }]
        }]
      }

      return {
        "itemType": "FROM_BACKEND",
        "type": "table",
        "commponentTypeName": "表格",
        "sequence": sequence,
        "required": required,
        "disabled": disabled,
        "conceal": conceal,
        "scale": scale,
        "draw": draw,
        "important": important,
        "img": item.img,
        "label": label,
        "options": {
          "width": "100%",
          "bordered": true,
          "bright": false,
          "customStyle": "",
          "noFormItem": true,
          "small": true,
        },
        "trs": trs,
        "model": model,
        "key": key,
        "help": help,
        "rules": rule,
        "common": common,
        "description": description,
        "isAddRow": isAddRow,
      }
    }
  }

  parseFormDesignData(formDesignData) {
    const formDesignDataList = formDesignData.list;
    const form = formDesignData.form;

    const multiLayerForms = this.parseFormDesignDataList(form.code, form.id, formDesignDataList, null);

    const singleLayerForm = [];
    this.arrOfOneDimension(singleLayerForm, multiLayerForms, 1);
    return singleLayerForm;
  }

  /**
   * 将 K-Form-Design 中的数据转换为 Erase 可以识别的格式。
   */
  parseFormDesignDataList(formCode, formId, formDesignDataList, parentCode) {
    let formDataList = [];

    for (let item of formDesignDataList) {
      let formData = this.parseSingleFormDesignData(formCode, formId, item, parentCode);

      // 如果返回的是数组（父子题情况），则展开数组
      if (Array.isArray(formData)) {
        formDataList = formDataList.concat(formData);
      } else {
        formDataList.push(formData);
      }
    }

    return formDataList;
  }

  parseSingleFormDesignData(formCode, formId, item, parentCode) {
    let baseForm = item.common;

    if (!baseForm) {
      baseForm = {
        "parent": null,
        "code": item.code,
        "dictItemList": null,
        "minLength": 0,
        "delFlag": 0,
        "isLeaf": true,
        "children": null,
        "parentCode": null,
        "sortNum": 0,
        "id": null,
        "parentValue": null,
        "formCode": formCode,
        "formId": formId,
        "length": null,
        "formTip": null,
        "reDecimal": null,
        "decimalPoint": null,
        "unit": null,
        "checkReg": null
      }
    }

    if (!baseForm.formCode) {
      baseForm.formCode = formCode
    }
    if (!baseForm.formId) {
      baseForm.formId = formId
    }

    if (!baseForm.code && typeof (baseForm.code) != "undefined" && baseForm.code != 0) {
      baseForm.code = this.generateShortId();
    }
    // 只有在parentCode为null或undefined时才设置默认值，保留用户设置的parentCode
    if (baseForm.parentCode === null || baseForm.parentCode === undefined) {
      baseForm.parentCode = parentCode;
    }

    baseForm.number = item.sequence;
    baseForm.inputTip = item.help;
    baseForm.name = item.label;
    baseForm.img = item.img;
    baseForm.description = item.description;

    let required = '0';
    if (item.required) {
      required = '1';
    }
    baseForm.required = required;
    let disabled = '0';
    if (item.disabled) {
      disabled = '1';
    }
    baseForm.disabled = disabled;
    let conceal = '0';
    if (item.conceal) {
      conceal = '1';
    }
    baseForm.conceal = conceal;
    let scale = '0';
    if (item.scale) {
      scale = '1';
    }
    baseForm.scale = scale;
    let draw = '0';
    if (item.draw) {
      draw = '1';
    }
    baseForm.draw = draw;
    let important = '0';
    if (item.important) {
      important = '1';
    }
    baseForm.important = important;

    // 只有在parentValue为null或undefined时才设置默认值，保留用户设置的parentValue
    if (baseForm.parentValue === null || baseForm.parentValue === undefined) {
      let parentValue = '';
      if (baseForm.parentValueList && baseForm.parentValueList.length > 0) {
        baseForm.parentValueList.forEach(item0 => {
          parentValue += item0 + ',';
        })
        if (parentValue.length > 0) {
          parentValue = parentValue.substring(0, parentValue.length - 1);
        }
      } else {
        parentValue = baseForm.parentValue;
      }

      baseForm.parentValue = parentValue || null;
    }
    console.log("-------baseForm-------", baseForm)
    // 如果是emptyCard类型，直接返回父子题列表，而不是嵌套结构
    if (item.type === 'emptyCard') {
      if (item.parent === null || item.parent.length !== 1) {
        throw new Error("存在空的父级卡片");
      }
      if (item.list === null || item.list.length < 1) {
        throw new Error("存在空的子级卡片");
      }

      // 获取父题目
      let parentForm = this.parseSingleFormDesignData(formCode, formId, item.parent[0], parentCode);

      // 获取子题目列表
      let childrenList = [];
      if (item.list) {
        childrenList = this.parseFormDesignDataList(formCode, formId, item.list, parentForm.code);
      }

      // 返回父题目和子题目列表
      let result = [parentForm];
      result = result.concat(childrenList);
      return result;
    } else if (item.type === 'radio') {
      let dictItemJson = JSON.stringify(item.options.options.map(item => {
        return {
          "value": item.value,
          "text": item.label,
          "mappingValue": item.mappingValue,
          "description": item.description,
          "sortNum": item.sortNum,
          "img": item.img,
          "defaultValue": item.defaultValue,
        };
      }
      )
      );
      console.log("-------dictItemJson12-------", dictItemJson)
      baseForm.dictItemJson = dictItemJson;
      baseForm.type = "select";
    } else if (item.type === 'uploadFile') {
      baseForm.type = "file";
    } else if (item.type === 'slider') {
      baseForm.type = "slider";
      baseForm.length = item.options.max;
      baseForm.minLength = item.options.min;
      baseForm.unit = item.options.unit;
    } else if (item.type === 'input') {
      baseForm.type = "text";
      baseForm.length = item.options.maxLength;
      baseForm.minLength = item.options.minLength;
      baseForm.checkReg = item.options.checkReg;
      baseForm.unit = item.options.addonAfter;
    } else if (item.type === 'textarea') {
      baseForm.type = "textarea";
      baseForm.length = item.options.maxLength;
      baseForm.minLength = item.options.minLength;
      baseForm.checkReg = item.options.checkReg;
      baseForm.unit = item.options.addonAfter;
    } else if (item.type === 'checkbox') {
      let dictItemJson = JSON.stringify(item.options.options.map(item => {
        return {
          "value": item.value,
          "text": item.label,
          "mappingValue": item.mappingValue,
          "description": item.description,
          "sortNum": item.sortNum,
          "img": item.img,
          "defaultValue": item.defaultValue,
        };
      }
      )
      );
      baseForm.dictItemJson = dictItemJson;
      baseForm.type = "check";
    } else if (item.type === 'knumber') {
      baseForm.type = "number";
      baseForm.length = item.options.max;
      baseForm.minLength = item.options.min;
      baseForm.unit = item.options.unit;
      baseForm.checkReg = item.options.checkReg;

      let reDecimal = '0';
      if (item.options.reDecimal) {
        reDecimal = '1';
      }
      baseForm.reDecimal = reDecimal;
      baseForm.decimalPoint = item.options.decimalPoint;
    } else if (item.type === 'time') {
      if (item.typeNew === 'hour') {
        baseForm.type = "hour";
      } else if (item.typeNew === 'minute') {
        baseForm.type = "minute";
      } else {
        baseForm.type = "time";
      }
    } else if (item.type === 'date') {
      if (item.typeNew === 'dateyear') {
        baseForm.type = "dateyear";
      } else {
        baseForm.type = "date";
      }
    } else if (item.type === 'datetime') {
      baseForm.type = "dateTime";
    } else if (item.type === 'dateyear') {
      baseForm.type = "dateyear";
    } else if (item.type === 'hour') {
      baseForm.type = "hour";
    } else if (item.type === 'minute') {
      baseForm.type = "minute";
    } else if (item.type === 'table') {
      //将前端页面数据 转换为 后端数据格式
      baseForm.type = "table";
      // 保存表格结构
      if (item.trs) {
        console.log("-------item.trs-------", item.trs)
        // 简化表格数据，只保存必要的信息
        const simplifiedTrs = JSON.parse(JSON.stringify(item.trs));
        simplifiedTrs.forEach(tr => {
          if (Array.isArray(tr.tds)) {
            tr.tds.forEach(td => {
              if (Array.isArray(td.list)) {
                td.list = td.list.map(({ label, type, options, isChecked, isRadio }) => {
                  let formattedOptions = [];
                  if (isChecked || isRadio) {
                    const optArray = Array.isArray(options) ? options : (options && Array.isArray(options.options) ? options.options : []);
                    if (optArray.length > 0) {
                      formattedOptions = optArray.map(opt => ({
                        value: opt.value !== undefined ? String(opt.value) : String(opt.label),
                        label: opt.label !== undefined ? String(opt.label) : String(opt.value)
                      }));
                    } else {
                      formattedOptions = [{ value: "1", label: "是" }];
                    }
                    type = isChecked?"checkbox":"radio";
                  }
                  return {
                    type: type,
                    label,
                    options: formattedOptions,
                    //model,
                    //key,
                    //ommon
                  };
                });
              }
            });
          }
          if (item.isAddRow) {
            tr.isAddRow = true;
          }else{
            tr.isAddRow = false;
          }
        });
        baseForm.trs = JSON.stringify(simplifiedTrs);
      }
    }

    // 如果不是emptyCard类型，返回baseForm
    return baseForm;
  }

  arrOfOneDimension(resultArray, multiArr, index) {
    multiArr.forEach(item => {
      const jsonItem = JSON.parse(JSON.stringify(item));
      jsonItem.children = null;
      jsonItem.sortNum = index;
      resultArray.push(jsonItem);

      if (Array.isArray(item.children) && item.children.length > 0) {
        index = this.arrOfOneDimension(resultArray, item.children, ++index)
      }

      ++index;
    })

    return index;
  }

  getParentNode(data = [], key) {
    let list = data.list;
    if (!list || !key) {
      return {}
    }
    let findParent = (item, nodeKey, parentVal) => {
      for (let i = 0; i < item.length; i++) {
        let node = item[i];

        if (!node) {
          continue;
        }

        if (node.key === nodeKey) {
          if (parentVal && parentVal.parent && parentVal.parent.length > 0) {
            return parentVal.parent[0];
          }

          return null;
        } else {
          if (node.list) {
            let targetParent = findParent(node.list, nodeKey, node);
            if (targetParent) {
              return targetParent;
            }
          }
          continue;
        }
      }
    }
    return findParent(list, key);
  }

  getParentNode2(data = [], key) {
    let list = data.list;
    if (!list || !key) {
      return {}
    }
    let findParent = (item, nodeKey, parentVal) => {
      for (let i = 0; i < item.length; i++) {
        let node = item[i];

        if (!node) {
          continue;
        }

        if (node.key === nodeKey) {
          if (parentVal && parentVal.parent && parentVal.parent.length > 0) {
            return parentVal.parent[0];
          }

          return null;
        } else {
          if (node.list) {
            let targetParent = findParent(node.list, nodeKey, node);
            if (targetParent) {
              return targetParent;
            } else {
              if (node.parent && node.parent.length > 0 && node.parent[0].key === nodeKey) {
                if (parentVal && parentVal.parent && parentVal.parent.length > 0) {
                  return parentVal.parent[0];
                }
              }
            }
          }
          continue;
        }
      }
    }
    return findParent(list, key);
  }

  generateUUID() {
    var d = new Date().getTime();
    var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  };

  generateShortId() {
    return "DISC-" + new Date().valueOf() + "-" + Math.floor((Math.random() * 10000) + 1);;
  }
}
export const eraseUtils = new EraseUtils();
